import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Menu } from 'semantic-ui-react'
import { navigationPaths } from '../constants/paths'
import { getApplicationCookie } from '../helpers/sessionHelpers'
import NavBarNotifications from './NavBarNotifications'

class TopNavBar extends React.Component {
  clearNotification = (notif) => {
    this.props.dispatch({
      type: 'SHOP_ORDER_NOTIFICATIONS_DELETE',
      payload: { data: { id: notif.notification_id } }
    })
  }

  clearAllNotifications = () => {
    this.props.dispatch({ type: 'SHOP_ORDER_NOTIFICATIONS_DELETE_ALL' })
  }

  render() {
    const signedIn = getApplicationCookie('authentication_token') !== ''
    const { notifications, location } = this.props
    const isShopOrders = location.pathname === navigationPaths.shopOrdersIndex()
    const isReconciliation = location.pathname === navigationPaths.reconciliationsIndex()

    return (
      <Menu fixed='top' inverted style={{margin: 0}} borderless>
        <Menu.Item>
          <Link to={`${navigationPaths.dashboard()}`}>CarAdvise</Link>
        </Menu.Item>
        <Menu.Item active={isShopOrders}>
          <Link to={`${navigationPaths.shopOrdersIndex()}`}>Shop Orders</Link>
        </Menu.Item>
        <Menu.Item active={isReconciliation}>
          <Link to={`${navigationPaths.reconciliationsIndex()}`}>Reconciliation</Link>
        </Menu.Item>
        <Menu.Menu position='right'>
          {notifications.length > 0 &&
            <Menu.Item style={{padding: 0}}>
              <NavBarNotifications
                notifications={notifications}
                clearNotification={this.clearNotification}
                clearAllNotifications={this.clearAllNotifications}
              />
            </Menu.Item>
          }
          {signedIn &&
            <Menu.Item position='right'>
              <Link to={`${navigationPaths.signOut()}`}>Sign Out</Link>
            </Menu.Item>
          }
        </Menu.Menu>
      </Menu>
    )
  }
}

const mapStateToProps = (state) => ({
  notifications: state.shopOrders.notifications
})

export default connect(mapStateToProps)(TopNavBar)
